var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('contact-dialog',{attrs:{"show":(_vm.show),"title":"温馨提示","cancelText":"我知道了","content":"儿童不能单独出行，请选择一名成年乘客同行","btnStyle":"fill"},on:{"cancel":_vm.cancelContactDialog}})
}
var staticRenderFns = []

export { render, staticRenderFns }